import 'rc-time-picker/assets/index.css';
import React, { Component } from 'react';
import moment from 'moment';
import TimePicker from 'rc-time-picker';
import './style.css';

const showSecond = true;
const str = showSecond ? 'HH:mm:ss' : 'HH:mm';

export default class DurationPicker extends Component {
    getInitial = () => {
        return this.props.initial;
    };

    componentDidMount() {
        this.getInitial();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.initial !== this.props.initial || prevState === null) this.getInitial();
    }

    handleChange = value => {
        const { passData } = this.props;
        passData(value && value.format(str));
    };

    render() {
        const { handleChange } = this;
        const defaultValue = moment(this.getInitial(), 'HH:mm:ss');

        return <TimePicker showSecond={showSecond} defaultValue={defaultValue} onChange={handleChange} />;
    }
}



// WEBPACK FOOTER //
// ./src/UI/Components/Pickers/TimePicker/index.js